import { render, staticRenderFns } from "./ConfirmRegisterModal.vue?vue&type=template&id=7d1a007b"
import script from "./ConfirmRegisterModal.vue?vue&type=script&lang=js"
export * from "./ConfirmRegisterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports